import React from 'react';

const AboutSection = () => {
  return (
    <section id="about">
      <div className="container">
        <div className="section-label">01 — About</div>
        <div className="about-grid">
          <div className="about-text reveal">
            <h2>Hi, I&apos;m Bill Bolte, Developer on the Plains</h2>
            <p>
              I am an applications developer with nearly three decades of experience across web and desktop applications. Throughout my career, I have successfully delivered custom solutions to a diverse client base, including corporate, charitable, and public sector organizations. I am committed to staying at the forefront of emerging technologies, open source projects, and industry trends.
            </p>
            <p>
              Through the years, I've worked with many tech stacks including: PHP, JavaScript, Ruby on Rails, Node.js, React.js, Expo & React Native, MySQL, PostgreSQL, LAMP, Ionic with Angular and many others. I've managed a team of developers and mentored junior programmers. I have a Scrum Master certificate and have worked in Agile environments.
            </p>
            <h3>A little background...</h3>
            <p>
              I started life as a graphic designer. Getting involved in the internet in the 90's changed my trajectory in a big way. Designing web sites eventually led me to cobbling together an Ecommerce store. It was magic and I was hooked. I went back to school to explore programming in much greater depth. This was the beginning of my quest into technology and how the second part of my life began.
            </p>
            <h3>Not only that...</h3>
            <p>
              I'm also a believer, a husband, a father and will brag that mine is the greatest family ever! I love the outdoors and when not coding, will spend as much time as I can outside. I'm frequently found on my bicycle riding the nearby rail trail or the singletrack. Hiking, camping and fishing are a favorite pastime. One of my passions in life is trout fishing in northern New Mexico and try to get back there frequently. I'm also a licensed ham radio operator (call sign: KEOJTI).
            </p>
            <p>
              I love to cook and try new recipes or continue to perfect favorites. In my opinion, one of the great pleasures in life is a perfectly grilled steak. Many a weekend, I can be found in my backyard hovering over the grill or manning the smoker or deep frying a turkey. Low country boil anyone? I've also started baking my own sourdough bread and can bake up a pretty mean loaf of bread, if I may so myself.
            </p>
            <h3>I also love coffee... way, way too much.</h3>
          </div>
          <div className="about-stats reveal">
            <div className="stat">
              <div className="stat-num">29<span>+</span></div>
              <div className="stat-label">Years experience</div>
            </div>
            <div className="stat">
              <div className="stat-num">8<span>+</span></div>
              <div className="stat-label">Core stacks</div>
            </div>
            <div className="stat">
              <div className="stat-num">3<span>+</span></div>
              <div className="stat-label">Decades in software</div>
            </div>
            <div className="stat">
              <div className="stat-num"><span>∞</span></div>
              <div className="stat-label">Coffees consumed</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;

